import { ProductState } from './types';

export const stateDict: Record<ProductState, string> = {
    0: 'Not new',
    1: 'New',
    2: 'Like new',
};

export const stateRuToEn: Record<string, string> = {
    'Новое': 'New',
    'Как новое': 'Like new',
    'Не новое': 'Not new',
};